define('app/views/product_image_slider_view',['app/setup', 'jquery.easing' ,'jquery.mobileJustTouch', 'mighty-slider'], function(takhfifan, easing, mobileJustTouch, mightyslider) {

  takhfifan.ProductImageSliderView = takhfifan.BaseView.extend({
    initialize: function() {
      var _this = this;
      this.$el.removeClass('loading');
      this.$('.main-slideshow-loading').fadeOut(500, function() {
        $(this).remove();
      });
      //main deal slideshow
      if(this.$('.bxslider').length) {
        var singleSlide = this.$('.bxslider').bxSlider({
          infiniteLoop: true,
          prevText: '',
          nextText: '',
          pause: 6000,
          pager: false,
          auto: true,
          mode: 'fade',
          onSlideBefore: function ($slideElement, oldIndex, newIndex) {
            var slidesCount = $(singleSlide[0]).find('li').length - 1;
            var slideEl = $($(singleSlide[0]).find('li'));
            _this.lazyLoading(1, slidesCount, newIndex, slideEl);
          }
        });

        //lazy loading on init
        var slidesCountInit = $(singleSlide[0]).find('li').length - 1;
        var slideElInit = $($(singleSlide[0]).find('li'));
        this.lazyLoading(1, slidesCountInit, 0, slideElInit)
      }


      // main slideshow
      var $win = $(window),
          isTouch = !!('ontouchstart' in window),
          clickEvent = isTouch ? 'tap' : 'click';
      function calculateWidth() {
        var percent = '100%',
            width = $(window).width();

        if (width >= 1200) {
          percent = 1200;
        } else {
          percent = '100%';
        }

        return percent;
      }

      (function(){
          var $carousel = _this.$('#mainSlideshow'),
          // var $carousel = $('#mainSlideshow'),
              $frame = $('.frame', $carousel),
              $tabs = $('.main-slideshow-tab ul');
          if(!$frame.length){return}

        var $slider = new mightySlider($frame,{
              speed: 1500,
              easing: 'easeOutExpo',
              startAt: 0,
              viewport: 'fill',

              navigation: {
                  activateOn: clickEvent,
                  slideSize: calculateWidth(),
                  isRtl : true
              },

              thumbnails: {
                  horizontal: 1,
                  preloadThumbnails: 0,
                  activateOn: clickEvent,
                  thumbnailsBar: $tabs,
                  thumbnailBuilder:
                  function (index, thumbnail) {
                    return '<li><span>' + this.slides[index].options.title + '</span></li>';
                  }
              },

              // Buttons options
              buttons: !isTouch ? {
                  prev: $('a.mSPrev', $frame),
                  next: $('a.mSNext', $frame)
              } : {},

              cycling: {
                  cycleBy: 'slides',
                  pauseTime: 6000,
                  pauseOnHover: 1,
                  loop: 1,
                  startPaused: 0,
                  loopMode : 'immediate' // it can be 'normal', 'pingpong' or 'immediate' 1807-tame-the-slider
              },

              dragging: {
                  swingSpeed: 0.1
              },

              commands: {
                  buttons: 1
              }
          });
        $slider.init();
        $win.resize(function () {
            // Update slider options using 'set' method
            $slider.set({
              navigation: {
                slideSize: calculateWidth()
              }
            });
          });
      })();

    },
  
    lazyLoading: function(bufferSize, slidesCount, index, el) {
      var _this = this;
      var upperBound = Math.min(slidesCount, index + bufferSize);
      for(var i = index; i <= upperBound; i++) {
        var element = el.eq(i);
        if (!(element.hasClass('lazy-loaded'))) {
          _this.loadImage(element);
        }
      }
    },

    loadImage: function (el) {
      var slideImage = $(el).find('img');
      slideImage.prop('src', slideImage.data('src'));
      $(el).addClass('lazy-loaded');
    }
  });
});

